(() => {
  const PARAM_NAME = 'featured';
  const GRID_SELECTOR = '#product-grid';
  const GRID_CONTAINER_SELECTOR = '#ProductGridContainer';
  const CARD_ITEM_SELECTOR = 'li.grid__item';

  const params = new URLSearchParams(window.location.search);
  const featuredHandle = cleanHandle(params.get(PARAM_NAME));

  if (!featuredHandle) return;

  let fetchedCardPromise = null;
  let isApplying = false;

  function cleanHandle(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9-]/g, '');
  }

  function routesRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    const match = window.location.pathname.match(/^(.*?\/)collections\//);
    return match ? match[1] : '/';
  }

  function productHref(handle) {
    return `${routesRoot()}products/${encodeURIComponent(handle)}`;
  }

  function isFeaturedProductUrl(url, handle) {
    if (!url) return false;

    const anchor = document.createElement('a');
    anchor.href = url;

    return anchor.pathname.replace(/\/$/, '').endsWith(`/products/${handle}`);
  }

  function findProductItems(root, handle) {
    return Array.from(root.querySelectorAll(CARD_ITEM_SELECTOR)).filter((item) => {
      return Array.from(item.querySelectorAll('a[href], button[data-product-url]')).some((node) => {
        return isFeaturedProductUrl(node.getAttribute('href') || node.dataset.productUrl, handle);
      });
    });
  }

  function updateAnimationIndexes(grid) {
    Array.from(grid.children).forEach((item, index) => {
      if (item.matches(CARD_ITEM_SELECTOR)) {
        item.style.setProperty('--index', index);
      }
    });
  }

  function preserveFeaturedParam() {
    document
      .querySelectorAll('#FacetFiltersForm, #FacetFiltersFormMobile, #FacetSortForm, #FacetSortDrawerForm')
      .forEach((form) => {
        if (!form.querySelector(`input[name="${PARAM_NAME}"]`)) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = PARAM_NAME;
          input.value = featuredHandle;
          form.appendChild(input);
        }
      });

    document.querySelectorAll('.pagination a[href], facet-remove a[href]').forEach((link) => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;

      const url = new URL(href, window.location.origin);
      if (!url.pathname.includes('/collections/')) return;

      url.searchParams.set(PARAM_NAME, featuredHandle);
      link.setAttribute('href', `${url.pathname}${url.search}${url.hash}`);
    });
  }

  function fetchFeaturedCard() {
    if (!fetchedCardPromise) {
      const url = `${productHref(featuredHandle)}?view=featured-card`;

      fetchedCardPromise = fetch(url, { credentials: 'same-origin' })
        .then((response) => {
          if (!response.ok) throw new Error(`Featured product card failed: ${response.status}`);
          return response.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          return doc.querySelector(`${GRID_SELECTOR} > ${CARD_ITEM_SELECTOR}`);
        })
        .catch(() => null);
    }

    return fetchedCardPromise;
  }

  async function applyFeaturedProduct() {
    if (isApplying) return;
    isApplying = true;

    try {
      preserveFeaturedParam();

      const grid = document.querySelector(GRID_SELECTOR);
      if (!grid) return;

      let matches = findProductItems(grid, featuredHandle);
      let featuredItem = matches[0] || null;

      if (!featuredItem) {
        const fetchedItem = await fetchFeaturedCard();
        if (!fetchedItem) return;

        featuredItem = fetchedItem;
        grid.prepend(featuredItem);
      } else if (grid.firstElementChild !== featuredItem) {
        grid.prepend(featuredItem);
      }

      findProductItems(grid, featuredHandle).forEach((item) => {
        if (item !== featuredItem) item.remove();
      });

      updateAnimationIndexes(grid);
    } finally {
      isApplying = false;
    }
  }

  document.addEventListener('DOMContentLoaded', applyFeaturedProduct);
  window.addEventListener('pageshow', applyFeaturedProduct);
  window.addEventListener('popstate', applyFeaturedProduct);

  const containerObserver = new MutationObserver(() => {
    window.requestAnimationFrame(applyFeaturedProduct);
  });

  const startObserver = () => {
    const container = document.querySelector(GRID_CONTAINER_SELECTOR);
    if (container) {
      containerObserver.observe(container, { childList: true, subtree: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
